import { render, staticRenderFns } from "./KundalikPechat.vue?vue&type=template&id=436accac"
import script from "./KundalikPechat.vue?vue&type=script&lang=js"
export * from "./KundalikPechat.vue?vue&type=script&lang=js"
import style0 from "./KundalikPechat.vue?vue&type=style&index=0&id=436accac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports